// HtmlSymbols.jsx
import React from "react";

const HtmlSymbols = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1>HTML Symbols - Comprehensive Notes</h1>

      {/* Introduction */}
      <section id="introduction">
        <h2>1. Introduction to HTML Symbols</h2>
        <p>
          HTML symbols are special characters that represent various icons, shapes,
          and non-standard keyboard characters. They are widely used for math, currency,
          arrows, and miscellaneous symbols.
        </p>
      </section>

      {/* Mathematical Symbols */}
      <section id="math-symbols">
        <h2>2. Mathematical Symbols</h2>
        <ul>
          <li>Plus &minus;: &minus; (−)</li>
          <li>Multiplication: &times; (×)</li>
          <li>Division: &divide; (÷)</li>
          <li>Less than or equal: &le; (≤)</li>
          <li>Greater than or equal: &ge; (≥)</li>
          <li>Not equal: &ne; (≠)</li>
          <li>Square root: &radic; (√)</li>
        </ul>
      </section>

      {/* Currency Symbols */}
      <section id="currency">
        <h2>3. Currency Symbols</h2>
        <ul>
          <li>Dollar: &dollar; ($)</li>
          <li>Pound: &pound; (£)</li>
          <li>Euro: &euro; (€)</li>
          <li>Yen: &yen; (¥)</li>
          <li>Cent: &cent; (¢)</li>
        </ul>
      </section>

      {/* Arrows and Directional Symbols */}
      <section id="arrows">
        <h2>4. Arrows & Directional Symbols</h2>
        <ul>
          <li>Left arrow: &larr; (←)</li>
          <li>Right arrow: &rarr; (→)</li>
          <li>Up arrow: &uarr; (↑)</li>
          <li>Down arrow: &darr; (↓)</li>
          <li>Bidirectional arrow: &harr; (↔)</li>
        </ul>
      </section>

      {/* Punctuation Symbols */}
      <section id="punctuation">
        <h2>5. Punctuation Symbols</h2>
        <ul>
          <li>Copyright: &copy; (©)</li>
          <li>Registered: &reg; (®)</li>
          <li>Trademark: &trade; (™)</li>
          <li>Section: &sect; (§)</li>
          <li>Paragraph: &para; (¶)</li>
          <li>Bullet: &bull; (•)</li>
        </ul>
      </section>

      {/* Mathematical Fractions */}
      <section id="fractions">
        <h2>6. Fractions</h2>
        <ul>
          <li>1/4: &frac14; (¼)</li>
          <li>1/2: &frac12; (½)</li>
          <li>3/4: &frac34; (¾)</li>
        </ul>
      </section>

      {/* Miscellaneous Symbols */}
      <section id="misc">
        <h2>7. Miscellaneous Symbols</h2>
        <ul>
          <li>Heart: &hearts; (♥)</li>
          <li>Diamond: &diams; (♦)</li>
          <li>Club: &clubs; (♣)</li>
          <li>Spade: &spades; (♠)</li>
          <li>Check mark: &#10003; (✓)</li>
          <li>Cross mark: &#10007; (✗)</li>
        </ul>
      </section>

      {/* Emoji Symbols */}
      <section id="emoji">
        <h2>8. Emoji Symbols</h2>
        <p>Smiley: &#x1F600;</p>
        <p>Thumbs Up: &#x1F44D;</p>
        <p>Computer: &#x1F4BB;</p>
      </section>

      {/* Best Practices */}
      <section id="best-practices">
        <h2>9. Best Practices</h2>
        <ul>
          <li>Use named entities for readability (&copy;, &hearts;).</li>
          <li>Use numeric codes for less common symbols (&#x1F600;).</li>
          <li>Ensure UTF-8 encoding to properly display symbols.</li>
          <li>Do not use symbols as a substitute for semantic content.</li>
        </ul>
      </section>
    </div>
  );
};

export default HtmlSymbols;
